
import Vue from 'vue'

function updateStoreState (stateKey, payloads) {
  // ensure we can handle single and multiple payloads
  if (!Array.isArray(payloads)) {
    payloads = [payloads]
  }

  payloads.forEach(payload => {
    let i = stateKey.findIndex((element) => element.id === payload.id)
    if (i > -1) {
      // create a fresh object by merging the old with the new
      payload = Object.assign({}, stateKey[i], payload)

      Vue.set(stateKey, i, payload)
    } else {
      stateKey.push(payload)
    }
  })
}

function deleteStoreState (stateKey, ids) {
  // ensure we can handle single and multiple deletions
  if (!Array.isArray(ids)) {
    ids = [ids]
  }

  ids.forEach(id => {
    const i = stateKey.findIndex((element) => element.id === id)
    if (i > -1) {
      // remove the item from the array
      stateKey.splice(i, 1)
    }
  })
}

function sortObjects (data, path, direction = 'asc', type = 'string') {
  return data.sort(function (a, b) {
    let x = path.split('.').reduce((value, el) => value[el], a)
    let y = path.split('.').reduce((value, el) => value[el], b)

    if (type === 'string') {
      x = x.toLowerCase()
      y = y.toLowerCase()
      return direction === 'desc' ? (x < y ? 1 : x > y ? -1 : 1) : (x < y ? -1 : x > y ? 1 : 0)
    } else if (type === 'int' || type === 'integer') {
      x = parseInt(x)
      y = parseInt(y)
      return direction === 'desc' ? y - x : x - y
    } else if (type === 'float') {
      x = parseFloat(x)
      y = parseFloat(y)
      return direction === 'desc' ? y - x : x - y
    } else if (type === 'date') {
      return direction === 'desc' ? new Date(y) - new Date(x) : new Date(x) - new Date(y)
    }
  })
}

export {
  updateStoreState,
  deleteStoreState,
  sortObjects,
}
